import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const PriorityUrgent = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.06845 2.38582C7.58296 1.8714 8.41723 1.87139 8.93173 2.38582L13.6143 7.06844C14.1288 7.58295 14.1288 8.41722 13.6143 8.93172L8.93173 13.6143C8.41723 14.1288 7.58296 14.1288 7.06845 13.6143L2.38583 8.93172C1.87139 8.41722 1.87139 7.58295 2.38583 7.06844L7.06845 2.38582ZM8.00107 10.3722C7.59014 10.3722 7.25693 10.7054 7.25693 11.1163C7.25694 11.5272 7.59015 11.8604 8.00107 11.8604C8.41192 11.8604 8.74519 11.5272 8.74521 11.1163C8.74521 10.7054 8.41193 10.3722 8.00107 10.3722ZM7.67294 4.13973C7.22961 4.13996 6.88027 4.51697 6.91318 4.95907L7.21493 8.98348C7.24496 9.38111 7.57593 9.68836 7.9747 9.68856H8.00204C8.39931 9.68842 8.72982 9.3834 8.76181 8.98739L9.087 4.96395C9.12286 4.51999 8.77167 4.13973 8.32626 4.13973H7.67294Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default PriorityUrgent;
